import React from 'react';

import { ProjectListDomain } from '../store/ProjectListDomain';

export const LeftProjectButtons: { Component: React.FC<{ domain: ProjectListDomain }> }[] = [];
